import { render } from "./LineHistory.vue?vue&type=template&id=643c234e"
import script from "./LineHistory.vue?vue&type=script&lang=js"
export * from "./LineHistory.vue?vue&type=script&lang=js"
script.render = render

export default script